const removeLocalStorage = name => localStorage.removeItem(name)

export default removeLocalStorage
